// extracted by mini-css-extract-plugin
export default {"image":"AntImage_image__on9oN","imageWrapper":"AntImage_imageWrapper__dfgJv"};